import { parse } from '@brillout/json-serializer/parse';
import { hasProp, objectAssign, assert } from './utils';
export { getPageContextSerializedInHtml };
function getPageContextSerializedInHtml() {
    var _a;
    const pageContextJson = (_a = document.getElementById('vite-plugin-ssr_pageContext')) === null || _a === void 0 ? void 0 : _a.textContent;
    assert(pageContextJson);
    const parseResult = parse(pageContextJson);
    assert(hasProp(parseResult, 'pageContext', 'object'));
    const { pageContext } = parseResult;
    assert(hasProp(pageContext, '_pageId', 'string'));
    /*
    if ('_serverSideErrorWhileStreaming' in pageContext) {
      const err = getProjectError(
        `An error occurred on the server while rendering/streaming to HTML. Check your server logs.`
      )
      throw err
    }
    */
    objectAssign(pageContext, {
        _pageContextRetrievedFromServer: { ...pageContext },
        _comesDirectlyFromServer: true
    });
    return pageContext;
}
